import React from 'react';
import { Switch, Route } from 'react-router-dom';

import AuthRoute from './authRoute';

import Login from 'modules/loginModule/index';
import Forgot from 'modules/loginModule/forgot';
import Home from 'modules/homeModule/index';
import Profile from 'modules/profileModule/index';
import Manage from 'modules/manageModule/index';
import Register from 'modules/registerModule/index';
import Account from 'modules/accountModule/index';
import Application from 'modules/applicationModule/index';
import Sample from 'modules/sampleModule/index';
import Unknow404 from 'components/unknow404';

const locale = ({ match }) => {
  return (
    <Switch>
      <Route exact path={`${match.url}/`}  component={Login}/>
      <Route path={`${match.url}/Login`} component={Login} />
      <AuthRoute path={`${match.url}/Home`} component={Home} />
      <AuthRoute path={`${match.url}/Profile`} component={Profile} />
      <AuthRoute path={`${match.url}/Manage`} component={Manage} />
      <AuthRoute path={`${match.url}/Register`} component={Register} />
      <AuthRoute path={`${match.url}/Account`} component={Account} />
      <AuthRoute path={`${match.url}/Sample`} component={Sample} />
      <Route path={`${match.url}/Application`} component={Application} />
      <Route path={`${match.url}/Forgot`} component={Forgot} />
      <Route path='*' component={Unknow404} />
    </Switch>
  )
}

export default locale;